// @ vendors
const React = require('react');
const { merge, cloneDeep } = require('lodash');

// @ components
const { InputSafe } = require('commonsComponents/inputSafe');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @constants
const { text, TYPE_OF_ROADS } = require('../initialValues');

const okSelect = (addressData, { options, label, name }) => {
    const textValue = text();
    return (
        <OKSelect
            label={textValue.LABEL[label]}
            name={name}
            options={options}
            value={addressData.data.fields[name].value}
            onChange={dataObject => addressData.onChange(name, dataObject)}
            errorMessage={textValue.MESSAGES.REQUIRED}
            errorState={addressData.data.validation[name]}
            searchable
        />
    )
};

const inputSafe = (addressData, { label, name, length }) => {
    const inputLength = typeof length !== 'undefined' ? length : '';
    const textValue = text();
    return (
        <InputSafe
            label={textValue.LABEL[label]}
            name={name}
            type="text"
            maxLength={inputLength}
            value={addressData.data.fields[name]}
            onChange={evt => addressData.onChange(name, evt.target.value)}
            errorMessage={textValue.MESSAGES.REQUIRED}
            errorState={addressData.data.validation[name]}
        />
    );
};

const config = {
    typeOfRoad: {
        options: TYPE_OF_ROADS,
        label: 'TYPE_OF_ROAD',
        name: 'typeOfRoad'
    },
    roadName: {
        label: 'ROAD_NAME',
        name: 'roadName'
    },
    numberStreet: {
        label: 'NUMBER_STREET',
        name: 'numberStreet'
    },
    another: {
        label: 'ANOTHER',
        name: 'another'
    },
    province: {
        options: [],
        label: 'PROVINCE',
        name: 'province'
    },
    population: {
        options: [],
        label: 'POPULATION',
        name: 'population',
    },
    postalCode: {
        label: 'POSTAL_CODE',
        name: 'postalCode',
        length: 5,
    },
};

const address = (addressData, mainOptions = false) => {
    const config_ = mainOptions ? merge(config, mainOptions) : cloneDeep(config);
    config_.province.options = addressData.provinces;
    config_.population.options = addressData.population;

    return (
        <div className="col-xs-12">
            <div className="row">
                <div className="col-xs-4 address__input">
                    {okSelect(addressData, config_.typeOfRoad)}
                </div>
                <div className="col-xs-8 address__input">
                    {inputSafe(addressData, config_.roadName)}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4 address__input">
                    {inputSafe(addressData, config_.numberStreet)}
                </div>
                <div className="col-xs-8 address__input">
                    {inputSafe(addressData, config_.another)}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4 address__input">
                    {okSelect(addressData, config_.province)}
                </div>
                <div className="col-xs-4 address__input">
                    {okSelect(addressData, config_.population)}
                </div>
                <div className="col-xs-4 address__input">
                    {inputSafe(addressData, config_.postalCode)}
                </div>
            </div>
        </div>
    )
};

module.exports = address;
